function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseWalletAdapter, LoginStateEnum, makeError, ERR_CODE, ConnectedWallet, utils, enhancedLocalStorage } from '@aelf-web-login/wallet-adapter-base';
import { getContractBasic } from '@portkey/contracts';
import { getBridges, formatLoginInfo, detectNightElf } from "./utils";
import zeroFill from "./zeroFill";
export var NightElfName = 'NightElf';

// TODO: initialWallet and setTimeout(()=>{},16000) in older version is nessary?
export var NightElfWallet = /*#__PURE__*/function (_BaseWalletAdapter) {
  _inherits(NightElfWallet, _BaseWalletAdapter);
  var _super = _createSuper(NightElfWallet);
  function NightElfWallet(config) {
    var _this;
    _classCallCheck(this, NightElfWallet);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "name", NightElfName);
    _defineProperty(_assertThisInitialized(_this), "icon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMUYxRjIxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUyNiAzLjY4YTEuNTA3IDEuNTA3IDAgMSAwIDAtMy4wMTMgMS41MDcgMS41MDcgMCAwIDAgMCAzLjAxNFptNi44MDggNC4zNGEzLjA2NiAzLjA2NiAwIDEgMS02LjEzMiAwIDMuMDY2IDMuMDY2IDAgMCAxIDYuMTMyIDBabS01LjMgNS44NDVhMS41MDcgMS41MDcgMCAxIDEtMy4wMTQgMCAxLjUwNyAxLjUwNyAwIDAgMSAzLjAxNCAwWk0uODA5IDMuNzg1Qy4zNjggNC45NTQuOTkxIDYuMjc5IDIuMTYgNi43MmMuNzguMjg2IDEuNjExLjEzIDIuMjA5LS4zNjRhMi4wMjIgMi4wMjIgMCAwIDEgMS45MjMtLjI2Yy40NDEuMTU2Ljc4LjQ0MiAxLjAxMy44MDZsLjAyNi4wNTJjLjEwNC4xNTYuMjYuMzExLjQ2OC4zNjNhLjkwNS45MDUgMCAwIDAgMS4xNjktLjU0NS45MDUuOTA1IDAgMCAwLS41NDYtMS4xNy44Ni44NiAwIDAgMC0uNjIzIDBjLS40MTYuMTMtLjg4NC4xMy0xLjMyNS0uMDI1QTIuMDU3IDIuMDU3IDAgMCAxIDUuMiA0LjIyNmwtLjAyNi0uMDUyYzAtLjAyNiAwLS4wNTEtLjAyNS0uMDUxVjQuMDdjLS4xODItLjcyOC0uNjc2LTEuMzUyLTEuNDMtMS42MTFBMi4yMSAyLjIxIDAgMCAwIC44MSAzLjc4NVpNMi4xNiA5LjMxOUMuOTkxIDkuNzYuMzY4IDExLjA4Ni44MSAxMi4yNTVjLjQ0MSAxLjE5NSAxLjc0IDEuNzkzIDIuOTEgMS4zMjUuNzUzLS4yNiAxLjI0Ny0uODgzIDEuNDI5LTEuNjExdi0uMDUyYy4wMjYgMCAuMDI2LS4wMjYuMDI2LS4wNTJsLjAyNS0uMDUyQTIuMDU3IDIuMDU3IDAgMCAxIDcuOCAxMC40MzZhLjg2Ljg2IDAgMCAwIC42MjMgMCAuOTA1LjkwNSAwIDAgMCAuNTQ2LTEuMTcuOTA1LjkwNSAwIDAgMC0xLjE3LS41NDVjLS4yMDcuMDUyLS4zNjMuMjA4LS40NjcuMzY0bC0uMDI2LjA1MmMtLjIzNC4zNjQtLjU3Mi42NS0xLjAxMy44MDUtLjY3Ni4yNi0xLjM3Ny4xMy0xLjkyMy0uMjZBMi4yNCAyLjI0IDAgMCAwIDIuMTYgOS4zMloiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=');
    _defineProperty(_assertThisInitialized(_this), "darkIcon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUyNiAzLjY4YTEuNTA3IDEuNTA3IDAgMSAwIDAtMy4wMTMgMS41MDcgMS41MDcgMCAwIDAgMCAzLjAxNFptNi44MDcgNC4zNGEzLjA2NiAzLjA2NiAwIDEgMS02LjEzMiAwIDMuMDY2IDMuMDY2IDAgMCAxIDYuMTMyIDBabS01LjMgNS44NDVhMS41MDcgMS41MDcgMCAxIDEtMy4wMTQgMCAxLjUwNyAxLjUwNyAwIDAgMSAzLjAxNCAwWk0uODEgMy43ODVDLjM2NyA0Ljk1NC45OSA2LjI3OSAyLjE2IDYuNzJjLjc4LjI4NiAxLjYxLjEzIDIuMjA5LS4zNjRhMi4wMjIgMi4wMjIgMCAwIDEgMS45MjItLjI2Yy40NDIuMTU2Ljc4LjQ0MiAxLjAxNC44MDZsLjAyNi4wNTJjLjEwNC4xNTYuMjYuMzExLjQ2Ny4zNjNhLjkwNS45MDUgMCAwIDAgMS4xNy0uNTQ1LjkwNS45MDUgMCAwIDAtLjU0Ni0xLjE3Ljg2Ljg2IDAgMCAwLS42MjQgMGMtLjQxNS4xMy0uODgzLjEzLTEuMzI1LS4wMjVBMi4wNTcgMi4wNTcgMCAwIDEgNS4yIDQuMjI2bC0uMDI2LS4wNTJjMC0uMDI2IDAtLjA1MS0uMDI2LS4wNTFWNC4wN2MtLjE4Mi0uNzI4LS42NzYtMS4zNTItMS40MjktMS42MTFhMi4yMSAyLjIxIDAgMCAwLTIuOTEgMS4zMjVaTTIuMTYgOS4zMTlDLjk5IDkuNzYuMzY3IDExLjA4Ni44MDkgMTIuMjU1Yy40NDIgMS4xOTUgMS43NCAxLjc5MyAyLjkxIDEuMzI1Ljc1My0uMjYgMS4yNDctLjg4MyAxLjQyOS0xLjYxMXYtLjA1MmMuMDI2IDAgLjAyNi0uMDI2LjAyNi0uMDUybC4wMjYtLjA1MmEyLjA1NyAyLjA1NyAwIDAgMSAyLjU5OC0xLjM3Ny44Ni44NiAwIDAgMCAuNjI0IDAgLjkwNS45MDUgMCAwIDAgLjU0Ni0xLjE3LjkwNS45MDUgMCAwIDAtMS4xNy0uNTQ1Yy0uMjA4LjA1Mi0uMzYzLjIwOC0uNDY3LjM2NGwtLjAyNi4wNTJjLS4yMzQuMzY0LS41NzIuNjUtMS4wMTQuODA1LS42NzUuMjYtMS4zNzcuMTMtMS45MjItLjI2QTIuMjQgMi4yNCAwIDAgMCAyLjE2IDkuMzJaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDE2djE2SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+');
    _defineProperty(_assertThisInitialized(_this), "_loginState", void 0);
    _defineProperty(_assertThisInitialized(_this), "_wallet", void 0);
    _defineProperty(_assertThisInitialized(_this), "_config", void 0);
    _this._loginState = LoginStateEnum.INITIAL;
    _this._wallet = null;
    _this._config = config;
    detectNightElf().then(function (type) {
      if (type === 'unknown' || type === 'none') {
        return;
      }
      _this.listenProviderEvents();
      _this.autoRequestAccountHandler(type);
    });
    return _this;
  }
  _createClass(NightElfWallet, [{
    key: "loginState",
    get: function get() {
      return this._loginState;
    }
  }, {
    key: "wallet",
    get: function get() {
      return this._wallet;
    }
  }, {
    key: "autoRequestAccountHandler",
    value: function () {
      var _autoRequestAccountHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
        var canLoginEargly;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              canLoginEargly = enhancedLocalStorage.getItem(ConnectedWallet);
              if (!(canLoginEargly !== this.name)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (this._config.connectEagerly) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return this.loginEagerly(type);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function autoRequestAccountHandler(_x) {
        return _autoRequestAccountHandler.apply(this, arguments);
      }
      return autoRequestAccountHandler;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isMobileDevices, nodes, appName, _yield$getBridges, bridge, bridges, node, result, _formatLoginInfo, account, pubKey, name, all;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isMobileDevices = utils.isMobileDevices;
              _context2.prev = 1;
              this._loginState = LoginStateEnum.CONNECTING;
              nodes = this._config.nodes;
              appName = this._config.appName;
              if (nodes) {
                _context2.next = 7;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_AELF_NODES);
            case 7:
              _context2.next = 9;
              return getBridges(nodes, appName);
            case 9:
              _yield$getBridges = _context2.sent;
              bridge = _yield$getBridges.bridge;
              bridges = _yield$getBridges.bridges;
              node = _yield$getBridges.node;
              _context2.next = 15;
              return bridge.login({
                chainId: node.chainId,
                payload: {
                  method: 'LOGIN'
                }
              });
            case 15:
              result = _context2.sent;
              if (!result.error) {
                _context2.next = 18;
                break;
              }
              throw result.errorMessage || result;
            case 18:
              if (!isMobileDevices()) {
                _context2.next = 22;
                break;
              }
              bridge === null || bridge === void 0 || bridge.connect();
              _context2.next = 24;
              break;
            case 22:
              _context2.next = 24;
              return Promise.all(Object.values(bridges).map(function (i) {
                return i.chain.getChainStatus();
              }));
            case 24:
              _formatLoginInfo = formatLoginInfo(result.detail), account = _formatLoginInfo.account, pubKey = _formatLoginInfo.pubKey, name = _formatLoginInfo.name, all = _formatLoginInfo.all;
              this._wallet = {
                name: name,
                address: account,
                extraInfo: {
                  publicKey: pubKey,
                  nightElfInfo: _objectSpread(_objectSpread({}, all), {}, {
                    defaultAElfBridge: bridge,
                    aelfBridges: bridges,
                    nodes: nodes
                  })
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              this.emit('connected', this._wallet);
              return _context2.abrupt("return", this._wallet);
            case 32:
              _context2.prev = 32;
              _context2.t0 = _context2["catch"](1);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.NIGHT_ELF_LOGIN_FAIL, _context2.t0));
              return _context2.abrupt("return");
            case 37:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 32]]);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "loginEagerly",
    value: function () {
      var _loginEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(type) {
        var instance, _yield$instance$AElf$, locked;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (!(type === 'NightElf')) {
                _context3.next = 9;
                break;
              }
              instance = window.NightElf || window.parent.NightElf;
              _context3.next = 5;
              return new instance.AElf({
                httpProvider: this._config.defaultRpcUrl
              }).getExtensionInfo();
            case 5:
              _yield$instance$AElf$ = _context3.sent;
              locked = _yield$instance$AElf$.locked;
              if (!locked) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return");
            case 9:
              _context3.next = 11;
              return this.login();
            case 11:
              _context3.next = 16;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](0);
              this.emit('error', makeError(ERR_CODE.NIGHT_ELF_LOGIN_EAGERLY_FAIL, _context3.t0));
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 13]]);
      }));
      function loginEagerly(_x2) {
        return _loginEagerly.apply(this, arguments);
      }
      return loginEagerly;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$_wallet, _this$_wallet2, address, defaultAElfBridge, result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              address = (_this$_wallet = this._wallet) === null || _this$_wallet === void 0 ? void 0 : _this$_wallet.address;
              defaultAElfBridge = (_this$_wallet2 = this._wallet) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.extraInfo) === null || _this$_wallet2 === void 0 ? void 0 : _this$_wallet2.nightElfInfo.defaultAElfBridge;
              if (!(!address || !defaultAElfBridge)) {
                _context4.next = 5;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 5:
              _context4.next = 7;
              return defaultAElfBridge.logout({
                address: address
              });
            case 7:
              result = _context4.sent;
              if (!(result !== null && result !== void 0 && result.error)) {
                _context4.next = 10;
                break;
              }
              throw result;
            case 10:
              this._wallet = null;
              this._loginState = LoginStateEnum.INITIAL;
              enhancedLocalStorage.removeItem(ConnectedWallet);
              this.emit('disconnected');
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](0);
              this.emit('error', makeError(ERR_CODE.NIGHT_ELF_LOGOUT_FAIL, _context4.t0));
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 16]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "getSignatureInMobileApp",
    value: function () {
      var _getSignatureInMobileApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
        var _this$_wallet$extraIn;
        var bridge, hex, signedMsgObject, signedMsgString;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this._wallet) {
                _context5.next = 2;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 2:
              bridge = (_this$_wallet$extraIn = this._wallet.extraInfo) === null || _this$_wallet$extraIn === void 0 || (_this$_wallet$extraIn = _this$_wallet$extraIn.nightElfInfo) === null || _this$_wallet$extraIn === void 0 || (_this$_wallet$extraIn = _this$_wallet$extraIn.aelfBridges) === null || _this$_wallet$extraIn === void 0 ? void 0 : _this$_wallet$extraIn[this._config.chainId];
              if (bridge) {
                _context5.next = 5;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 5:
              if (bridge.sendMessage) {
                _context5.next = 7;
                break;
              }
              throw new Error('bridge.sendMessage is not a function');
            case 7:
              hex = '';
              if (params.hexToBeSign) {
                hex = params.hexToBeSign;
              } else {
                hex = params.signInfo;
              }
              _context5.next = 11;
              return bridge.sendMessage('keyPairUtils', {
                method: 'sign',
                arguments: [hex]
              });
            case 11:
              signedMsgObject = _context5.sent;
              if (signedMsgObject) {
                _context5.next = 14;
                break;
              }
              throw new Error('signedMsgObject is null');
            case 14:
              if (!(signedMsgObject !== null && signedMsgObject !== void 0 && signedMsgObject.error)) {
                _context5.next = 16;
                break;
              }
              throw new Error(signedMsgObject.errorMessage.message || signedMsgObject.errorMessage || signedMsgObject.message);
            case 16:
              signedMsgString = [zeroFill(signedMsgObject.r), zeroFill(signedMsgObject.s), "0".concat(signedMsgObject.recoveryParam.toString())].join('');
              return _context5.abrupt("return", {
                error: 0,
                errorMessage: '',
                signature: signedMsgString,
                from: 'aelf-bridge'
              });
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getSignatureInMobileApp(_x3) {
        return _getSignatureInMobileApp.apply(this, arguments);
      }
      return getSignatureInMobileApp;
    }()
  }, {
    key: "getSignature",
    value: function () {
      var _getSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
        var _this$_wallet$extraIn2;
        var bridge, hex, signature;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (params.hexToBeSign) {
                console.error('getSignature: hexToBeSign is deprecated, please use signInfo instead, signInfo is utf-8 string not hex');
              }
              if (this._wallet) {
                _context6.next = 3;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 3:
              bridge = (_this$_wallet$extraIn2 = this._wallet.extraInfo) === null || _this$_wallet$extraIn2 === void 0 || (_this$_wallet$extraIn2 = _this$_wallet$extraIn2.nightElfInfo) === null || _this$_wallet$extraIn2 === void 0 || (_this$_wallet$extraIn2 = _this$_wallet$extraIn2.aelfBridges) === null || _this$_wallet$extraIn2 === void 0 ? void 0 : _this$_wallet$extraIn2[this._config.chainId];
              if (bridge) {
                _context6.next = 6;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 6:
              if (bridge.getSignature) {
                _context6.next = 10;
                break;
              }
              _context6.next = 9;
              return this.getSignatureInMobileApp(params);
            case 9:
              return _context6.abrupt("return", _context6.sent);
            case 10:
              hex = '';
              if (params.hexToBeSign) {
                hex = params.hexToBeSign;
              } else {
                hex = params.signInfo;
              }
              _context6.next = 14;
              return bridge.getSignature({
                address: params.address,
                hexToBeSign: hex
              });
            case 14:
              signature = _context6.sent;
              return _context6.abrupt("return", signature);
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getSignature(_x4) {
        return _getSignature.apply(this, arguments);
      }
      return getSignature;
    }()
  }, {
    key: "getAccountByChainId",
    value: function () {
      var _getAccountByChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this$_wallet3;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this._wallet) {
                _context7.next = 2;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 2:
              return _context7.abrupt("return", ((_this$_wallet3 = this._wallet) === null || _this$_wallet3 === void 0 ? void 0 : _this$_wallet3.address) || '');
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getAccountByChainId() {
        return _getAccountByChainId.apply(this, arguments);
      }
      return getAccountByChainId;
    }()
  }, {
    key: "getWalletSyncIsCompleted",
    value: function () {
      var _getWalletSyncIsCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this$_wallet4;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this._wallet) {
                _context8.next = 2;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 2:
              return _context8.abrupt("return", ((_this$_wallet4 = this._wallet) === null || _this$_wallet4 === void 0 ? void 0 : _this$_wallet4.address) || '');
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getWalletSyncIsCompleted() {
        return _getWalletSyncIsCompleted.apply(this, arguments);
      }
      return getWalletSyncIsCompleted;
    }()
  }, {
    key: "listenProviderEvents",
    value: function listenProviderEvents() {
      var _this2 = this;
      var onNightElfLockWallet = function onNightElfLockWallet() {
        _this2.logout();
      };
      if (typeof window !== 'undefined') {
        document.addEventListener('nightElfLockWallet', onNightElfLockWallet);
      }
    }
  }, {
    key: "getContract",
    value: function () {
      var _getContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(chainId, contractAddress) {
        var _this$_wallet$extraIn3;
        var bridge;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this._wallet) {
                _context9.next = 2;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 2:
              bridge = (_this$_wallet$extraIn3 = this._wallet.extraInfo) === null || _this$_wallet$extraIn3 === void 0 || (_this$_wallet$extraIn3 = _this$_wallet$extraIn3.nightElfInfo) === null || _this$_wallet$extraIn3 === void 0 || (_this$_wallet$extraIn3 = _this$_wallet$extraIn3.aelfBridges) === null || _this$_wallet$extraIn3 === void 0 ? void 0 : _this$_wallet$extraIn3[chainId];
              if (bridge) {
                _context9.next = 5;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 5:
              return _context9.abrupt("return", getContractBasic({
                contractAddress: contractAddress,
                aelfInstance: bridge,
                account: {
                  address: this._wallet.address
                }
              }));
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getContract(_x5, _x6) {
        return _getContract.apply(this, arguments);
      }
      return getContract;
    }()
  }, {
    key: "callSendMethod",
    value: function () {
      var _callSendMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref) {
        var _this$_wallet$extraIn4;
        var chainId, contractAddress, methodName, args, sendOptions, finalChainId, bridge, contract, rs;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              chainId = _ref.chainId, contractAddress = _ref.contractAddress, methodName = _ref.methodName, args = _ref.args, sendOptions = _ref.sendOptions;
              if (this._wallet) {
                _context10.next = 3;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 3:
              if (contractAddress) {
                _context10.next = 5;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 5:
              finalChainId = chainId || this._config.chainId;
              bridge = (_this$_wallet$extraIn4 = this._wallet.extraInfo) === null || _this$_wallet$extraIn4 === void 0 || (_this$_wallet$extraIn4 = _this$_wallet$extraIn4.nightElfInfo) === null || _this$_wallet$extraIn4 === void 0 || (_this$_wallet$extraIn4 = _this$_wallet$extraIn4.aelfBridges) === null || _this$_wallet$extraIn4 === void 0 ? void 0 : _this$_wallet$extraIn4[finalChainId];
              if (bridge) {
                _context10.next = 9;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 9:
              _context10.next = 11;
              return this.getContract(finalChainId, contractAddress);
            case 11:
              contract = _context10.sent;
              rs = contract.callSendMethod(methodName, this._wallet.address, args, sendOptions);
              return _context10.abrupt("return", rs);
            case 14:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function callSendMethod(_x7) {
        return _callSendMethod.apply(this, arguments);
      }
      return callSendMethod;
    }()
  }, {
    key: "callViewMethod",
    value: function () {
      var _callViewMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref2) {
        var _this$_wallet$extraIn5;
        var chainId, contractAddress, methodName, args, finalChainId, bridge, contract, rs;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              chainId = _ref2.chainId, contractAddress = _ref2.contractAddress, methodName = _ref2.methodName, args = _ref2.args;
              if (this._wallet) {
                _context11.next = 3;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 3:
              if (contractAddress) {
                _context11.next = 5;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 5:
              finalChainId = chainId || this._config.chainId;
              bridge = (_this$_wallet$extraIn5 = this._wallet.extraInfo) === null || _this$_wallet$extraIn5 === void 0 || (_this$_wallet$extraIn5 = _this$_wallet$extraIn5.nightElfInfo) === null || _this$_wallet$extraIn5 === void 0 || (_this$_wallet$extraIn5 = _this$_wallet$extraIn5.aelfBridges) === null || _this$_wallet$extraIn5 === void 0 ? void 0 : _this$_wallet$extraIn5[finalChainId];
              if (bridge) {
                _context11.next = 9;
                break;
              }
              throw makeError(ERR_CODE.NIGHT_ELF_NOT_CONNECTED);
            case 9:
              _context11.next = 11;
              return this.getContract(finalChainId, contractAddress);
            case 11:
              contract = _context11.sent;
              rs = contract.callViewMethod(methodName, args);
              return _context11.abrupt("return", rs);
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function callViewMethod(_x8) {
        return _callViewMethod.apply(this, arguments);
      }
      return callViewMethod;
    }()
  }]);
  return NightElfWallet;
}(BaseWalletAdapter);